import { loadCheckoutWebComponents } from "@checkout.com/checkout-web-components";
import { useSnackbarContext } from "@repo/contexts/SnackbarContext";
import { ckoCreateSession } from "@repo/server-actions/checkout";
import { useEffect, useRef, useState, useTransition } from "react";

const appearance = {
  colorAction: "#E5A855",
};

const useCkoPayment = ({
  cartTotal,
  selectedAddress,
  locale,
  beginPlaceOrder,
}) => {
  const [isCkoLoading, setIsCkoLoading] = useState(true);
  const [isPending, startTransition] = useTransition();
  const flowComponentRef = useRef(null);
  const containerRef = useRef(null);
  const hasInitialized = useRef(false);
  const { setSnackbar } = useSnackbarContext();

  useEffect(() => {
    if (hasInitialized.current) return;
    hasInitialized.current = true;

    const initCkoRender = async () => {
      try {
        const paymentSession = await ckoCreateSession(
          selectedAddress,
          cartTotal,
          locale
        );

        const checkout = await loadCheckoutWebComponents({
          publicKey: process.env.NEXT_PUBLIC_CKO_PUBLIC_KEY,
          environment: "sandbox",
          locale: "en-GB",
          paymentSession,
          appearance,
          componentOptions: {
            flow: {
              //expandFirstPaymentMethod: false,
            },
          },
          onReady: () => {
            setIsCkoLoading(false);
          },
          onPaymentCompleted: (_component, paymentResponse) => {
            // TODO: delete this commented code when feature is ready with tokenization
            /* const { status, id } = paymentResponse;
            const isApproved = status === "Approved";
            const redirectUrl = `${process.env.NEXT_PUBLIC_FRONTEND_REDIRECT_URL_CKO}?status=${
              isApproved ? "success" : "failed"
            }&payment_id=${id}`;
            router.push(redirectUrl);*/
          },
          onChange: () => {},
          onError: (component, error) => {
            console.error("onError", error, "Component", component.type);
          },
          onSubmit: async (component) => {
            console.log(`onSubmit() -> isSubmitting: for ${component.type}`);
          },
        });

        const flowComponent = checkout.create("flow", { showPayButton: false });
        flowComponent.mount(containerRef.current);
        flowComponentRef.current = flowComponent;
      } catch (err) {
        console.log("Error loading Checkout.com:", err);
        setIsCkoLoading(false);
      }
    };

    initCkoRender();
  }, [cartTotal, selectedAddress, locale]);

  const handleCkoPayButton = () => {
    if (!flowComponentRef.current) return;

    startTransition(async () => {
      try {
        const { data, cardMetadata } =
          (await flowComponentRef.current.tokenize()) || {};

        if (cardMetadata) {
          beginPlaceOrder({ data, cardMetadata });
        } else {
          setSnackbar({
            open: true,
            message: "Please enter valid card details",
            type: "error",
          });
        }
      } catch (err) {
        console.error("Tokenization failed:", err);
      }
    });
  };

  return {
    containerRef,
    isPending,
    handleCkoPayButton,
    isCkoLoading,
  };
};

export default useCkoPayment;
